import React, { useState } from 'react';

interface CopyableFieldProps {
  label?: string;
  value: string;
  copyValue?: string;
}

export function CopyableField({ label, value, copyValue }: CopyableFieldProps) {
  const [copied, setCopied] = useState(false);
  const [hovering, setHovering] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(copyValue ?? value);
    setCopied(true);
    setHovering(false);
  };

  const showCopyAgain = copied && hovering;
  const actionText = copied ? (showCopyAgain ? 'Copy again' : 'Copied') : 'Copy';
  const actionClasses = ['copyable-field__action', showCopyAgain && 'copyable-field__action--again']
    .filter(Boolean)
    .join(' ');
  const iconClasses = [
    'copyable-field__icon',
    copied ? 'copyable-field__icon--check' : 'copyable-field__icon--copy',
  ].join(' ');

  return (
    <div className="copyable-field">
      {label && <label className="pdq-input-label pdq-input-label--form-field react-input-label">{label}</label>}
      <button
        type="button"
        className="copyable-field__field"
        onClick={handleCopy}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}>
        <span className="copyable-field__value">{value}</span>
        <span className={actionClasses}>
          {actionText}
          {!showCopyAgain && <span className={iconClasses} />}
        </span>
      </button>
    </div>
  );
}
